const HistoryUtil = (function() {
	if (window.history) {
		window.history.scrollRestoration = 'auto';
	}

	return {
		replaceState: function(data, title, url) {
			if (window.history && window.history.replaceState) {
				window.history.replaceState(data, title, url);
			}
		},
		pushState: function(data, title, url) {
			if (window.history && window.history.replaceState) {
				window.history.pushState(data, title, url);
			}
		},
		isReload: function() {
			if (window.performance && window.performance.getEntriesByType('navigation').length > 0) {
				return window.performance.getEntriesByType('navigation')[0].type === 'reload';
			} else {
				return window.performance.navigation.type === 1;
			}
		},
		disableScrollRestoration: function() {
			if (window.history) {
				window.history.scrollRestoration = 'manual';
			}
		},
		reloadWithoutQuery: function() {
			if (location.href.indexOf('?') !== -1) {
				location.href = location.href.substr(0, location.href.indexOf('?'));
			} else {
				location.reload();
			}
		}
	};
})();

export default HistoryUtil;
